module.exports = __webpack_public_path__ + "img/gr.74479b6b.svg";